import React, { FunctionComponent } from 'react';

import { StandardPillProps } from '@components/library/pill';
import { BasePill } from '../base';
import styleClasses from './standard-pill.module.scss';

export const StandardPill: FunctionComponent<StandardPillProps> = (
  props
) => {
  const baseProps = {
    ...props,
    styleClasses,
    variantName: 'standard',
  };

  return <BasePill {...baseProps} />;
};
